import PostPageView from "../../components/community/post_pageview";

const UserArticlesScreen = () => {
    return <PostPageView isAdmin={false} isPost={false} />
}

export default UserArticlesScreen;